/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckIn1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CheckIn from 'DesignSystem/CheckIn/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckIn1({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content/Appointment/Action/Action/CheckIn"
  
}) {
let appointmentBookingValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let appointmentBookingPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'patient_id',
})
  return (<React.Fragment
>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
 data="appointment_booking"
 appointmentBooking={appointmentBookingValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="appointment_booking.patient_id"
 patientId={appointmentBookingPatientIdValueData}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 size="small"
 text="Check in"
/>
)}
</CheckIn>
{children}
</React.Fragment>)
}